import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Avatar, Button, Skeleton, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Text } = Typography;
const cloudFrontKey = process.env.REACT_APP_CLOUDFRONT_KEY;

const UserDetails = (props: any) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    user,
    loading,
    loaded,
    actions: { getUserById },
  } = props;

  useEffect(() => {
    getUserById({ id });
  }, []);

  if (loading || !user) {
    return (
      <div>
        <Skeleton active paragraph={{ rows: 6 }} />
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-between h-full gap-4">
      <div className="flex items-center">
        {user?.profilePictureKey ? (
          <Avatar
            className="min-w-[150px] h-[150px]"
            icon={<UserOutlined />}
            src={`${cloudFrontKey}/${user?.profilePictureKey}`}
          />
        ) : (
          <Avatar
            className="min-w-[150px] h-[150px]"
            icon={<UserOutlined className="text-6xl" />}
          />
        )}

        <div className="ml-5 flex flex-col gap-2 w-full">
          <Text className="text-neutral-600 font-semibold text-lg leading-4 block -mb-1">
            {user?.name}
          </Text>
          <Text className="text-neutral-500 text-sm leading-4 block">
            {user?.email}
          </Text>
          <div>
            <Text className="text-neutral-600 font-semibold text-[15px] leading-4 block mb-1">
              Department
            </Text>
            <Text className="text-neutral-600 font-semibold text-[15px] leading-4 block w-ful rounded-lg px-4 py-3 bg-neutral-100 h-10">
              {user?.assignments?.departments.length > 0
                ? user?.assignments?.departments?.[0].name
                : "-"}
            </Text>
          </div>
          <div>
            <Text className="text-neutral-600 font-semibold text-[15px] leading-4 block mb-1">
              Position
            </Text>
            <Text className="text-neutral-600 font-semibold text-[15px] leading-4 block w-ful rounded-lg px-4 py-3 bg-neutral-100 h-10">
              {user?.assignments?.positions.length > 0
                ? user?.assignments?.positions?.[0].name
                : "-"}
            </Text>
          </div>
        </div>
      </div>

      <div className="flex w-full gap-4">
        <div className="w-full bg-rose-400 border-none text-white rounded-lg flex flex-row items-center gap-1 justify-center h-8">
          <Text className="text-white text-base leading-6 font-semibold">
            {user?.points}
          </Text>
          <Text className="text-white text-[10px] leading-3">PTS</Text>
        </div>
        <Button
          onClick={() => navigate(`/educator/user/${user?.id}`)}
          type="primary"
          className="w-full h-8 bg-primary-600 font-semibold text-sm rounded-lg leading-[16px]"
        >
          Edit User
        </Button>
      </div>
    </div>
  );
};
export default UserDetails;
